/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography, breakpoints } from '@coursera/cds-core';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

type Props = {
  title: string;
  description?: React.ReactNode;
  content: React.ReactNode;
  anchorId?: string;
  sidebar?: React.ReactNode;
};

const styles = {
  description: () => css`
    margin-top: var(--cds-spacing-300);
  `,
  contentContainer: () => css`
    border: 2px solid var(--cds-color-grey-50);
    border-radius: 8px;
    padding: var(--cds-spacing-200) var(--cds-spacing-400) 0;
    ${breakpoints.down('xs')} {
      padding: 0 var(--cds-spacing-200);
    }
  `,
};

const ProjectContentModule = ({ title, description, content, sidebar, anchorId }: Props) => {
  const eventingProductData = useEventingProductData();

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_page_section',
    {
      pageSection: {
        sectionName: 'syllabus',
      },
      ...eventingProductData,
    }
  );

  return (
    <Section anchorId={anchorId} ref={visibilityTrackingRef}>
      <PageGridContainer>
        <Grid item xs={12} lg={8} md={7}>
          <Typography variant="h1semibold" component="h2">
            {title}
          </Typography>
          {description && <div css={styles.description}>{description}</div>}
        </Grid>
        <Grid item xs={12} lg={8} md={7}>
          <div css={styles.contentContainer}>{content}</div>
        </Grid>
        <Grid item xs={12} lg={4} md={5}>
          {sidebar && <div css={styles.contentContainer}>{sidebar}</div>}
        </Grid>
      </PageGridContainer>
    </Section>
  );
};

export default ProjectContentModule;
